module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Ladder-97604ee7a2dabeed9150f09922dd1aad.svg";